import { render } from "./BaseSpinnerMini.vue?vue&type=template&id=6f604306&scoped=true"
import script from "./BaseSpinnerMini.vue?vue&type=script&lang=js"
export * from "./BaseSpinnerMini.vue?vue&type=script&lang=js"

import "./BaseSpinnerMini.vue?vue&type=style&index=0&id=6f604306&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f604306"
/* hot reload */
if (module.hot) {
  script.__hmrId = "6f604306"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f604306', script)) {
    api.reload('6f604306', script)
  }
  
  module.hot.accept("./BaseSpinnerMini.vue?vue&type=template&id=6f604306&scoped=true", () => {
    api.rerender('6f604306', render)
  })

}

script.__file = "src/ui/BaseSpinnerMini.vue"

export default script